<template>
  <!-- ========== Left Sidebar Start ========== -->
  <div class="vertical-menu2 d-flex flex-column custom-scrollbar" style="background-color: #2A3042;">
    <div class="sidebar--logo">
      <div class="">
        <img :src="whiteLabel || '/logo-white.png'" alt="" height="52" />
      </div>
    </div>

    <router-link tag="a" to="/">
      <div class="user-panel">
        <i class="iconoir-view-grid"></i>
        {{ $t("dashboard.text") }}
      </div>
    </router-link>

    <router-link tag="a" to="/workspace">
      <div class="menu-item">
        <i class="iconoir-home-simple"></i>
        {{ $t("workspace.dashboard") }}
      </div>
    </router-link>

    <router-link tag="a" to="/workspace/members">
      <div class="menu-item">
        <i class="iconoir-community"></i>
        {{ $t("workspace.members") }}
      </div>
    </router-link>

    <router-link tag="a" to="/workspace/workspaces">
      <div class="menu-item">
        <i class="iconoir-link"></i>
        {{ $t("workspace.my") }}
      </div>
    </router-link>

    <!-- İhtiyaç halinde kullanılabilir

    <router-link tag="a" to="/workspace/edit">
      <div class="menu-item">
        <i class="iconoir-settings"></i>
        {{ $t("workspace.settings") }}
      </div>
    </router-link>  -->

    <router-link tag="a" to="/workspace/organizations">
      <div class="menu-item">
        <i class="iconoir-building"></i>
        {{ $t("organization.plural") }}
      </div>
    </router-link>

    <simplebar v-if="!isCondensed" :settings="settings">
      <SideNav />
    </simplebar>

    <simplebar v-else>
      <SideNav />
    </simplebar>

    <router-link tag="a" to="/workspace/members">
      <div class="menu-item m-auto mb-5" @click="openInviteModal">
        <i class="iconoir-user-plus"></i>
        {{ $t("workspace.send-invite") }}
      </div>
    </router-link>
  </div>

  <!-- Left Sidebar End -->
</template>

<script>
import simplebar from "simplebar-vue";

import SideNav from "./side-nav";

export default {
  components: { simplebar, SideNav },
  props: {
    isCondensed: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      required: false,
    },
    width: {
      type: String,
      required: false,
    },
  },
  computed: {},
  data() {
    return {
      settings: {
        minScrollbarLength: 60,
      },
    };
  },
  methods: {
    openInviteModal() {
      this.$store.commit("workspace/showInviteModal", true);
    },
  },
  mounted() {},
  watch: {},
};
</script>

<style lang="scss" scoped>
.user-panel {
  display: flex;
  align-items: center;
  padding-left: 2.5rem;
  gap: 1rem;
  color: #fff;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-bottom: 3.38rem;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.5rem 1rem;
  color: #535a71;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  max-width: 15rem;
  width: 100%;
  border-radius: 0.625rem;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 1rem;
  transition: background-color, color, 0.3s;
  cursor: pointer;

  i {
    position: relative;
    bottom: 1px;
    font-size: 1.5rem;
  }

  &:hover {
    background-color: #202533;
    color: #fff;

    i {
      color: #ff7c48;
    }
  }
}

.mm-active .menu-item {
  background-color: #202533;
  color: #fff;

  i {
    color: #ff7c48;
  }
}

/* width */
.custom-scrollbar::-webkit-scrollbar {
  width: 8px;
}

/* Track */
.custom-scrollbar::-webkit-scrollbar-track {
  box-shadow: inset 0 0 3px rgb(66, 83, 113);
  border-radius: 10px;
}

/* Handle */
.custom-scrollbar::-webkit-scrollbar-thumb {
  // background: rgb(66, 83, 113);
  background-color: #ff7c48;
  border-radius: 10px;
}
</style>
